





























































import {Component, Vue} from 'vue-property-decorator'
import {TimeEntries} from "@/models/time-entries";

@Component({
    name:  "UserTimeEntriesList"
})
export default class UserTimeEntriesList extends Vue {

    fields: object[] = [
        {key: 'project_name', label: 'Project', sortable: true},
        {key: 'issue_id', label: 'Issue ID'},
        {key: 'tracker', label: 'Tracker'},
        {key: 'subject', label: 'Subject'},
        {key: 'status', label: 'Status'},
        {key: 'estimated_hours', label: 'Estimated Hours'},
        {key: 'hours', label: 'Hours'},
        {key: 'total_hours', label: 'Total Hours'},
        {key: 'done_ratio', label: 'Done Ratio'},
        {key: 'expected_hours', label: 'Expected Hours'},
        {key: 'activity', label: 'Activity'},
        {key: 'comments', label: 'Comments'},
        {key: 'spent_on', label: 'Spent On'}
    ];

    totalRows = 1;
    currentPage = 1;
    perPage = 15;
    pageOptions = [10, 15, 25];
    sortBy = 'spent_on';
    sortDesc = true;
    sortDirection = 'asc';
    filter = null;

    userTimeEntries: Array<TimeEntries> = new Array<TimeEntries>();

    mounted() {
        if (localStorage.getItem('userTimeEntries')) {
            try {
                this.userTimeEntries = JSON.parse(localStorage.getItem('userTimeEntries') || '{}');
                this.totalRows = this.userTimeEntries.length;
            } catch(e) {
                console.log(e)
            }
        }
    }
}
